import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ConfigurationService, RootPageConfiguration} from '@irisims/justconsult-api';
import {take, tap} from 'rxjs/operators';
import {Router, RouterStateSnapshot} from '@angular/router';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';

@Injectable({
  providedIn: 'root'
})
export class RedirectUrlService {

  configObject$ = new BehaviorSubject<RootPageConfiguration>(null);

  constructor(private configService: ConfigurationService,
              private router: Router) {
  }

  fetchRedirectUrl(): Promise<RootPageConfiguration>{
    return this.configService.getRootPageCondiguration()
      .pipe(
        take(1),
        tap(data => {
          this.configObject$.next(data);

        })
      ).toPromise();
  }

  logoutRedirect(state?: RouterStateSnapshot, action?: MatDialogRef<any> ): void {
    switch (this.configObject$.value.mode) {
      case 'external':
        localStorage.setItem('link', this.configObject$.value.urlFull);
        window.location.href = this.configObject$.value.urlFull;
        break;
      case 'internal':
        this.router.navigate(['/login'], {queryParams: {returnUrl: state?.url}}).then(value => action?.close());
        break;
    }
  }
}
